"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalSetComparison = exports.SignalSetRowSchema = void 0;
exports.signalSetRowKeyForName = signalSetRowKeyForName;
const z = require("zod");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.SignalSetRowSchema = z.object({
    signalId: z.string(),
    signalName: z.string(),
    pins: z.string().array(),
    attributes: z.string(),
    description: z.string(),
});
const IDENTITY_COLUMNS = ['signalName'];
class SignalNameIdentityAlignment extends comparison_spec_1.SetAlignment {
    identityOf(row, normalize) {
        return JSON.stringify(IDENTITY_COLUMNS.map((column) => [column, normalize(column, row[column], row)]));
    }
}
function signalSetRowKeyForName(signalName) {
    return JSON.stringify([['signalName', (0, signal_name_normalization_1.normalizeSignalNameForComparison)(signalName)]]);
}
class SignalSetComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new SignalNameIdentityAlignment();
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return this.alignment.identityOf(row, (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        return super.normalize(column, value, row);
    }
}
exports.SignalSetComparison = SignalSetComparison;
//# sourceMappingURL=signal-set.comparison.js.map